module.exports = __webpack_public_path__ + "img/cosmos.61ecaa1a.png";